import React, {useState} from "react";
import GenericTemplate from "../../../templates/GenericTemplate";
import {
  apollo_useStyles,
  options_reviewstatus,
  options_reviewreason,
  valueToOptionNull, options_mimetype
} from "../../../atom/Apollo_styles";
import {crassetedit_path, get_zeus_resources_images_path} from "../../../atom/Apollo_links";
import {ApolloContext} from "../../../atom/Apollo_Context";
import {APOLLO_SYSTEM_ADMIN, APOLLO_GROUP_OPERATOR, ApolloUserProfileAuth} from "../../../atom/Apollo_Authorization";
import axios from "axios"
import {ApolloMessage, CustomizedSnackbars} from "../../../atom/Apollo_Mesasge"
import {Link, useHistory, useParams} from "react-router-dom";
import Fab from '@material-ui/core/Fab';
import AddIcon from "@material-ui/icons/Add";
import CardContent from "@material-ui/core/CardContent";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Tooltip from '@material-ui/core/Tooltip';
import Card from "@material-ui/core/Card/Card";
import {createMuiTheme} from "@material-ui/core/styles";
import {MUISortOptions, SelectableRows} from "mui-datatables";
import {CrAssetsImageRow} from "./CrAssetModel";
import {ApolloDataTable, STORAGE_KEY} from "../../../atom/Apollo_DataTable";
import {Backdrop} from "@material-ui/core";
import {Bars} from "react-loader-spinner";
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../../atom/Apollo_Breadcrumbs2";
import Typography from "@material-ui/core/Typography";
import Button from '@material-ui/core/Button';
import {APOLLO_PAGE_ID} from "../../../common/Apollo_LocalStorageSettings";

function a11yProps(index: any) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const valueToLabel = function (value: any, options: Array<{ value: any; label: string }>): string {
  let option = options.find(option => option.value === value)
  if (!option) {
    return ""
  } else {
    return option.label
  }
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const {children, value, index, ...other} = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {children}
    </div>
  );
}

const CrAssetsPageZeus: React.FC = () => {
  const classes = apollo_useStyles();
  const history = useHistory();
  const [tabstate, setTabstate] = React.useState(0);
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTabstate(newValue);
  };
  const {state} = React.useContext(ApolloContext);
  const {data, setmsg} = React.useContext(ApolloMessage);
  const [images, setImages] = useState<CrAssetsImageRow[]>([]);
  //const [videos, setVideos] = useState<CrAssetsVideoRow[]>([]);
  const {accountid, platformaccountid} = useParams<{accountid: string; platformaccountid: string}>()

  const breadcrumbsData: BreadcrumbsData = {
    categoryId: 16,
    breadId: 1,
    queries: [],
    menu: {
      id: 1,
      accountId: platformaccountid,
      accountName: "",
    },
    campaign: null,
    adgroup: null,
    advertisement: null,
    asset: null,
  }

  // 画像
  React.useEffect(() => {
    if (tabstate === 0) {
      setmsg({
        type: "loading",
        payload: {
          ...data,
          loading: true
        }
      });

      const url = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_resources_images_path}?account_id=${platformaccountid}&per_page=9999&page=1&sort=created&direction=desc`
      const fetchData = async () => {
        const result = await axios.get(
          url,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${state.accesstoken}`,
            }
          }
        ).then(result => {
          setImages(result.data);
        }).catch(err => {
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: "クリエイティブ情報（画像）の取得に失敗しました。"
            }
          });
          alert(err);
        }).finally(() => {
          setmsg({
            type: "loading",
            payload: {
              ...data,
              loading: false,
            }
          });
          setProgress(false)
        });
      };
      fetchData();
    }
  }, [tabstate]);

  const theme = createMuiTheme({});
  const imageColumns = [
    {
      name: "id",
      label: "広告アセットID",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({style: {minWidth: "6rem"}}),
      }
    },
    {
      name: "originalFileName",
      label: "画像ファイル名",
      options: {
        filter: true,
        sort: true,
        setCellProps: () => ({style: {minWidth: "6rem"}}),
      },
    },
    {
      name: "url",
      label: "画像プレビュー",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({style: {textAlign: "center"}}),
        customBodyRender: (value: string) => {
          return (
            <img
              src={value}
              alt=""
              style={{maxHeight: "80px"}}
            />
          );
        },
      }
    },
    {
      name: "width",
      label: "幅(px)",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "height",
      label: "高さ(px)",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "mimeTypeId",
      label: "MIME種別",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: number) => {
          const mimeType = valueToOptionNull(String(value), options_mimetype);
          return mimeType ? mimeType.label : "不明";
        }
      }
    },
  ];

  const [sortOrder, setSortOrder] = useState<MUISortOptions>({
    name: "id",
    direction: 'desc',
  })
  const imageSelectableRows: SelectableRows = 'none';
  const imageOptions = {
    filter: true,
    download: false,
    print: false,
    sort: true,
    search: false,
    selectableRows: imageSelectableRows,
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 25, 50],
    jumpToPage: true,
    expandableRows: false,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    elevation: 0,
    sortOrder: localStorage.getItem(STORAGE_KEY.ZEUS_CR_ASSETS_LIST) ? undefined : sortOrder,
    storageKey: STORAGE_KEY.ZEUS_CR_ASSETS_LIST,
    apolloPageId: APOLLO_PAGE_ID.AD_ASSET_LIST_ZEUS,
    textLabels:{
      body: {noMatch: "該当データが存在しません"}
    },
  }

  // 動画
  /*
  React.useEffect(() => {
      if( tabstate === 1) {
          const url = process.env.REACT_APP_API_ENDPOINT + get_zeus_resources_videos_path + "?accountId=" + platformaccountid ;
          const fetchData = async () => {
              const result = await axios.get(
                  url,
                  {
                      headers: {
                          'Content-Type': 'application/json',
                          'Authorization': `Bearer ${state.accesstoken}`,
                      }
                  }
              ).then(result => {
                  setVideos(result.data);
              }).catch(err => {
                  setmsg ({
                      type: "setMessage",
                      payload: {
                          ...data,
                          open:true,
                          type:"error",
                          message:"クリエイティブ情報（動画）の取得に失敗しました。"
                      }});
                  alert(err);
              });
          };
          fetchData();
      }
  },[tabstate]);
  */

  // const videoColumns = [
  //   {
  //     name: "url",
  //     label: "動画プレビュー",
  //     options: {
  //       filter: false,
  //       sort: false,
  //       customBodyRender: (value: string) => {
  //         return (
  //           <iframe width="270" height="180" src={value}
  //                   allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">
  //           </iframe>
  //         );
  //       },
  //     }
  //   },
  //   {
  //     name: "width",
  //     label: "幅",
  //     options: {
  //       filter: true,
  //       sort: false,
  //     }
  //   },
  //   {
  //     name: "height",
  //     label: "高さ",
  //     options: {
  //       filter: true,
  //       sort: false,
  //     }
  //   },
  //   {
  //     name: "fileName",
  //     label: "ファイル名",
  //     options: {
  //       filter: true,
  //       sort: false,
  //     }
  //   },
  //   {
  //     name: "reviewStatus",
  //     label: "審査状態",
  //     options: {
  //       filter: true,
  //       sort: false,
  //       customBodyRender: (value: number) => {
  //         return valueToLabel(String(value), options_reviewstatus);
  //       }
  //     }
  //   },
  //   {
  //     name: "reviewReason",
  //     label: "否認理由",
  //     options: {
  //       filter: true,
  //       sort: false,
  //       customBodyRender: (value: null | number) => {
  //         return valueToLabel(value ? String(value) : "null", options_reviewreason);
  //       }
  //     }
  //   },
  //   {
  //     name: "",
  //     label: "詳細",
  //     options: {
  //       filter: false,
  //       sort: false,
  //       customBodyRenderLite: (idx: number) => {
  //         return (
  //           <KeyboardArrowRightIcon
  //             onClick={() => history.push(crasset_path + platformaccountid + "/movie/" + videos[idx].id)}
  //             className={classes.link}
  //             style={{cursor: "pointer"}}
  //           />
  //         );
  //       }
  //     },
  //   },
  // ];
  //
  // const videoSelectableRows: SelectableRows = 'none';
  // const videoOptions = {
  //   filter: true,
  //   download: false,
  //   print: false,
  //   sort: false,
  //   selectableRows: videoSelectableRows,
  //   rowsPerPage: 5,
  //   rowsPerPageOptions: [5, 10, 20],
  //   jumpToPage: true,
  //   expandableRows: false,
  //   expandableRowsHeader: false,
  //   expandableRowsOnClick: false,
  // }

  const [progress, setProgress] = useState(true);

  return (
    <GenericTemplate title="">
      <Backdrop className={classes.backdrop2} open={progress}>
        <Bars color="#00BFFF" height={80} width={80} />
      </Backdrop>
      <CustomizedSnackbars/>
      <ApolloBreadcrumbs2 data={breadcrumbsData}/>
      <React.Fragment>
        <Card className={classes.root} square variant="outlined">
          <CardContent>
            <Divider/>
            <Tabs value={tabstate} onChange={handleChange} aria-label="simple tabs example">
              <Tab label="画像" {...a11yProps(0)} />
            </Tabs>
            <TabPanel value={tabstate} index={0}>
              <ApolloUserProfileAuth role={APOLLO_GROUP_OPERATOR} profile={APOLLO_SYSTEM_ADMIN}>
                <Grid container>
                  <Grid item xs={6}>
                    <Tooltip title="広告アセット（画像）新規作成" placement="bottom">
                      <Link to={`${crassetedit_path}zeus/image/${state.current.accountGroupId}/${accountid}/${platformaccountid}`} className={classes.link}>
                        <Fab size="small" color="primary" aria-label="image" style={{marginTop: "10px"}}>
                          <AddIcon/>
                        </Fab>
                      </Link>
                    </Tooltip>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="button" component="div" align="right">
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {history.push(`${crassetedit_path}zeus/image/${state.current.accountGroupId}/${accountid}/${platformaccountid}?type=mu`)}}
                        className={classes.button}
                      >
                        一括アップロード
                      </Button>
                    </Typography>
                  </Grid>
                </Grid>
              </ApolloUserProfileAuth>
              <Card className={classes.root} square variant="outlined">
                <ApolloDataTable
                  title=""
                  data={images? images: []}
                  columns={imageColumns}
                  options={imageOptions}
                />
              </Card>
            </TabPanel>
            {/*<TabPanel value={tabstate} index={1}>*/}
            {/*  <Card className={classes.root} square variant="outlined">*/}
            {/*    <MuiThemeProvider theme={theme}>*/}
            {/*      <MUIDataTable*/}
            {/*        title=""*/}
            {/*        data={videos? videos: []}*/}
            {/*        columns={videosColumns}*/}
            {/*        options={videosOptions}*/}
            {/*      />*/}
            {/*    </MuiThemeProvider>*/}
            {/*  </Card>*/}
            {/*</TabPanel>*/}
          </CardContent>
        </Card>
      </React.Fragment>
    </GenericTemplate>
  );
};

export default CrAssetsPageZeus;
